import VueGpickr from './VueGpickr';
import LinearGradient from './LinearGradient';
import * as vueColor from '@ckpack/vue-color';

export default VueGpickr;

export {
  VueGpickr,
  LinearGradient,
  vueColor
};
